import type { ApiErrorItem } from '@/types/api';

type SetConfirmDialog = (data: { title: string; content?: string }) => void;

type ExportApiError = Error & {
  errors?: ApiErrorItem[];
  message: string;
};

function resolveExportErrorMessage(error: unknown): string {
  const e = error as ExportApiError;
  const fromErrors =
    Array.isArray(e.errors) && e.errors[0]?.message ? e.errors[0].message : undefined;
  if (fromErrors) return fromErrors;
  if (error instanceof Error && error.message) return error.message;
  return String(error);
}

/** Shared handler for schedule & achievement export API errors. Uses global confirm dialog (modal), not snackbar. */
export function handleOutputReportsExportError(
  error: unknown,
  setConfirmDialog: SetConfirmDialog
): void {
  setConfirmDialog({ title: resolveExportErrorMessage(error) });
}
